import React, {type ReactNode} from 'react';
import {animated, useTransition} from 'react-spring';

import {Icon} from '@famly/mf_data-display_icon';
import {Text} from '@famly/mf_data-display_text';
import {Stack} from '@famly/mf_layout_stack';
import {needsTranslations} from 'web-app/util/scoped-needs-translation';

type Props = {children: ReactNode; isOpen: boolean; onToggle: VoidFunction};

const CollapsibleContainer = ({children, isOpen, onToggle}: Props) => {
    const transitions = useTransition(isOpen, null, {
        from: {opacity: 0, maxHeight: '0px'},
        enter: {opacity: 1, maxHeight: '500px', width: '100%'},
        leave: {opacity: 0, maxHeight: '0px'},
        config: {
            duration: 200,
        },
    });

    return (
        <Stack direction="column" borderTop="n100" pt={5} data-e2e-id="more-options" alignItems="flex-start">
            <Stack
                onClick={onToggle}
                spacing={2}
                alignItems="center"
                data-e2e-id="more-options-button"
                cursor="pointer"
            >
                <Text variant="body" color="n300">
                    {needsTranslations('SimplifiedUsBilling', 'More options')}
                </Text>
                <Icon name={isOpen ? 'expand_more' : 'chevron_right'} color="n300" />
            </Stack>
            {transitions.map(({item: isOpen, key, props: styles}) => {
                return isOpen ? (
                    <animated.div style={styles} key={key}>
                        <Stack direction="column" spacing={5} mt={5}>
                            {children}
                        </Stack>
                    </animated.div>
                ) : null;
            })}
        </Stack>
    );
};

export {CollapsibleContainer};
